module.exports = __webpack_public_path__ + "768e5eb661c0a8d728b31941ba63b7e4.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/chico.png
// module id = 2152
// module chunks = 0